import * as R from "ramda";
import {
    tableConfigDetailUnit,
    tableConfigUnitKekurangan,
    tableConfigUnitKelebihan,
    tableConfigUnitReportSO
} from "./configUnit";
import {
    tableConfigDetailKSU,
    tableConfigKSUKekurangan,
    tableConfigKSUKelebihan,
    tableConfigKSUReportSO
} from "./configKSU";
import M from "moment/moment";
import {tableConfigDetailHadiah, tableConfigGiftKekurangan, tableConfigGiftPartKelebihan, tableConfigResolveHadiah} from "./configHadiah";
import {tableConfigDetailOtherItem, tableConfigOtherItemKekurangan, tableConfigOtherItemKelebihan, tableConfigOtherItemReportSO} from "./configOtherItem";
import { tableConfigDetailPart, tableConfigPartKekurangan, tableConfigPartKelebihan, tableConfigPartReportSO } from "./configPart";

export const formGroup = {
    noStockOpname: {value: null, mandatory: false},
    stockOpnameDate: {value: M(new Date()).format("DD-MM-YYYY"), mandatory: true},
    stockOpnameType: {value: {}, mandatory: true},
    kodeCabang: {value: null, mandatory: true},
    kodeLocation: {value: null, mandatory: true},
};

export const getTableConfig = (tab, type, handleTableValueChange, onDeleteRow) => {
    switch (type) {
        case "UNIT":
            return R.equals("with_qr", tab) ? tableConfigDetailUnit.withQR : tableConfigDetailUnit.withoutQR;
        case "KSU":
            return R.equals("with_qr", tab) ? tableConfigDetailKSU.withQR : tableConfigDetailKSU.withoutQR;
        case "GIFT":
            return R.equals("with_qr", tab) ? tableConfigDetailHadiah.withQR : tableConfigDetailHadiah.withoutQR(handleTableValueChange, onDeleteRow);
        case "OTHER_ITEM":
            return R.equals("with_qr", tab) ? tableConfigDetailOtherItem.withQR : tableConfigDetailOtherItem.withoutQR(handleTableValueChange, onDeleteRow);
        case "PART":
            return R.equals("with_qr", tab) ? tableConfigDetailPart.withQR : tableConfigDetailPart.withoutQR(handleTableValueChange, onDeleteRow);
        default:
            break  
    }
}

export const getTableConfigReport = (tab, type) => {
    switch (type) {
        case "UNIT":
            return R.equals("with_qr", tab) ? tableConfigUnitReportSO.withQR : tableConfigUnitReportSO.withoutQR;
        case "KSU":
            return R.equals("with_qr", tab) ? tableConfigKSUReportSO.withQR : tableConfigKSUReportSO.withoutQR;
         case "PART":
            return R.equals("with_qr", tab) ? tableConfigPartReportSO.withQR : tableConfigPartReportSO.withoutQR;
        case "GIFT":
            return R.equals("with_qr", tab) ? tableConfigResolveHadiah.withQR : tableConfigResolveHadiah.withoutQR;
        case "OTHER_ITEM":
            return R.equals("with_qr", tab) ? tableConfigOtherItemReportSO.withQR : tableConfigOtherItemReportSO.withoutQR;
        default:
            break
    }
}

export const getTableConfigKelebihan = (type, dataDDL, onChange, dataKelebihan, handleTableValueChange, onDeleteRow, dataKekurangan) => {
    switch (type) {
        case "UNIT":
            return tableConfigUnitKelebihan;
        case "KSU":
            return tableConfigKSUKelebihan;
        case "GIFT":
            return tableConfigGiftPartKelebihan(dataDDL, onChange, dataKelebihan, handleTableValueChange, onDeleteRow, dataKekurangan);
         case "PART":
            return tableConfigPartKelebihan(dataDDL, onChange, dataKelebihan, handleTableValueChange, onDeleteRow, dataKekurangan);
        case "OTHER_ITEM":
            return tableConfigOtherItemKelebihan(dataDDL, onChange, dataKelebihan, handleTableValueChange, onDeleteRow, dataKekurangan);
        default:
            break
    }
}

export const getTableConfigKekurangan = (tab, type) => {
  switch (type) {
    case "UNIT":
      return R.equals("with_qr", tab) ? tableConfigUnitKekurangan.withQR : tableConfigUnitKekurangan.withoutQR;

    case "KSU": 
        return R.equals("with_qr", tab) ? tableConfigKSUKekurangan.withQR : tableConfigKSUKekurangan.withoutQR;
    case "GIFT":
        return R.equals("with_qr", tab) ? tableConfigGiftKekurangan.withQR : tableConfigGiftKekurangan.withoutQR;
    case "OTHER_ITEM":
      return R.equals("with_qr", tab) ? tableConfigOtherItemKekurangan.withQR : tableConfigOtherItemKekurangan.withoutQR;
    case "PART":
       return R.equals("with_qr", tab) ? tableConfigPartKekurangan.withQR : tableConfigPartKekurangan.withoutQR;
    default:
      break 
  }
};